export default "__VITE_ASSET__4e47d688__"